// src/stone/icons/Whatsapp.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Whatsapp = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "m.072 32 2.25-8.217a15.8 15.8 0 0 1-2.117-7.927C.208 7.113 7.324 0 16.067 0a15.76 15.76 0 0 1 11.22 4.65 15.76 15.76 0 0 1 4.641 11.218c-.003 8.743-7.12 15.857-15.861 15.857h-.007a15.86 15.86 0 0 1-7.58-1.93zm8.798-5.076.481.286a13.17 13.17 0 0 0 6.71 1.837h.006c7.266 0 13.18-5.912 13.183-13.18a13.1 13.1 0 0 0-3.858-9.324 13.1 13.1 0 0 0-9.32-3.865C8.8 2.678 2.886 8.59 2.882 15.857a13.15 13.15 0 0 0 2.016 7.014l.314.498-1.332 4.864z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M12.102 9.227c-.322-.772-.648-.668-.892-.68-.23-.011-.495-.014-.76-.014-.263 0-.693.1-1.056.496-.363.397-1.387 1.355-1.387 3.305s1.42 3.834 1.618 4.099c.198.264 2.795 4.266 6.77 5.983.946.408 1.685.651 2.26.834.95.302 1.813.26 2.496.157.762-.114 2.345-.958 2.675-1.884s.33-1.719.232-1.884c-.1-.165-.364-.264-.76-.463-.396-.198-2.345-1.157-2.708-1.289s-.628-.198-.892.199c-.264.396-1.024 1.289-1.255 1.553-.23.265-.462.297-.858.1-.397-.2-1.674-.617-3.188-1.967-1.178-1.05-1.973-2.348-2.204-2.745s-.025-.611.173-.809c.179-.177.397-.462.595-.694s.264-.396.396-.66c.132-.265.066-.497-.033-.695s-.892-2.148-1.222-2.942",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
var Whatsapp_default = Whatsapp;

export {
  Whatsapp_default
};
